import React from "react";
import { FaBell } from "react-icons/fa";
import { Link } from "react-router-dom";
import { SubTitle } from "../../../Components/CustomComponents";
import { WEB_ROUTES } from "../../../constants";
import { baseRoute } from "../../../Helper";
import styles from "../styles/Dashboard.module.scss";

export default function DashboardHeader({ onRunClick }) {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.titleContainer}>
        <SubTitle text={"Dashboard"} classes="primary-text" />
        <p className={styles.subtitle}>Engagement analytics overview</p>
      </div>
      <div className={styles.headerActions}>
        <Link
          to={baseRoute(WEB_ROUTES.SEND_NOTIFICATION)}
          className={styles.linkBtn}
        >
          <FaBell /> Send notification
        </Link>
        <button
          type="button"
          className={styles.secondaryBtn}
          onClick={onRunClick}
        >
          Run engagement campaigns
        </button>
      </div>
    </div>
  );
}
